import React from "react";
import Axios from "axios";

const ParagraphInput = (props) => {
  const piid = `paragraph-input-${props.id}`;
  const saveField = () => {
    const field = `<div className='px-2'><p className="card-text">${
      document.getElementById(piid).value
    }</p></div>`;
    Axios.post("https://fitness-junction-bots.onrender.com/api/savefield", {
      postId: props.postId,
      postField: field,
    })
      .then((data) => {})
      .catch((error) => console.log(error));
  };
  return (
    <div className="pi-container text-start">
      <textarea
        className="w-100 p-2 mt-2 form-control "
        id={piid}
        placeholder="Enter Your Paragraph Here."
      ></textarea>
      <button
        type="button"
        onClick={saveField}
        className="btn btn-success  mt-2"
      >
        Save
      </button>
    </div>
  );
};

export default ParagraphInput;
